"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
const react_1 = require("react");
const useResizeObserver = (callback) => {
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useLayoutEffect)(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const observer = new ResizeObserver((entries) => {
            callback(element, entries[0]);
        });
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [callback, ref]);
    return ref;
};
exports.useResizeObserver = useResizeObserver;
exports.default = exports.useResizeObserver;
